import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

import { ref } from 'vue';
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = {
  class: "dialog-footer"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'Error',
  setup(__props, {
    expose: __expose
  }) {
    const data = ref();
    const dialogVisible = ref(false);
    const open = showData => {
      data.value = showData;
      dialogVisible.value = true;
    };
    const close = () => {
      dialogVisible.value = false;
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        ref: "dialog",
        title: "详情",
        width: "65%",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        onClose: close
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("关闭")])),
          _: 1
        })])]),
        default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("p", null, "异常日志", -1)), _createElementVNode("p", {
          innerHTML: _unref(data)?.replace(/\r\n/g, '<br/>')
        }, null, 8, _hoisted_1)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});